import React, { ComponentProps } from 'react';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { RoleSettingsDefaultForm } from './views/RoleSettingsDefaultForm';

type RoleValidForPageTypeSettingsProps = Views<DefaultView<RoleSettingsDefaultForm>>;
function RoleValidForPageTypeSettings(props: RoleValidForPageTypeSettingsProps) {
  return <RoleSettingsDefaultForm {...props.views.default} />;
}

export const RoleValidForPageTypeSettingsBlock = asBlock(
  RoleValidForPageTypeSettings,
  BlockType.rolevalidforpagetypesettings,
);
export type RoleValidForPageTypeSettingsBlock = ComponentProps<typeof RoleValidForPageTypeSettingsBlock>;
